// ui/web/src/components/buzz/BuzzErrorState.tsx
import { SvgUnplug as WifiOffIcon } from "@opal/icons"

export function BuzzErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-3 p-6 text-center">
      <WifiOffIcon className="size-8 text-[var(--status-error-01)] opacity-70" aria-hidden />
      <p className="text-sm text-[var(--text-02)]">
        Could not connect to Buzz. Check your relay configuration.
      </p>
      <button
        id="btn-buzz-retry"
        className="btn btn-outline btn-sm"
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  )
}
